export enum EDatePickerMode {
	today = 'today',
	yesterday = 'yesterday',
	currentWeek = 'currentWeek',
	last7Days = 'last7Days',
	currentMonth = 'currentMonth',
	lastMonth = 'lastMonth',
	last30Days = 'last30Days',
	currentYear = 'currentYear',
	pastYear = 'pastYear',
}

export const DATE_PICKER_MODE_LABEL_MAP: Record<EDatePickerMode, string> = {
	[EDatePickerMode.today]: `date_picker_mode.${EDatePickerMode.today}`,
	[EDatePickerMode.yesterday]: `date_picker_mode.${EDatePickerMode.yesterday}`,
	[EDatePickerMode.currentWeek]: `date_picker_mode.${EDatePickerMode.currentWeek}`,
	[EDatePickerMode.last7Days]: `date_picker_mode.${EDatePickerMode.last7Days}`,
	[EDatePickerMode.currentMonth]: `date_picker_mode.${EDatePickerMode.currentMonth}`,
	[EDatePickerMode.lastMonth]: `date_picker_mode.${EDatePickerMode.lastMonth}`,
	[EDatePickerMode.last30Days]: `date_picker_mode.${EDatePickerMode.last30Days}`,
	[EDatePickerMode.currentYear]: `date_picker_mode.${EDatePickerMode.currentYear}`,
	[EDatePickerMode.pastYear]: `date_picker_mode.${EDatePickerMode.pastYear}`
}